import navigation from './navigation';
import menu from './menu';
// import loading from './loading';
// import scroll from './scroll';

export default () => {
	navigation();
	menu();
	// 	loading();
	// 	scroll();
};
